import { computed } from 'vue'

import { Role } from '~~/shared/Roles'

import { useSession } from './useAuthClient.client'

export const useUser = () => {
  const session = useSession()
  const user = computed(() => session.value.data?.user)

  const roles = computed<Role[]>(() => {
    if (!user.value) return []

    const r: Role[] = [Role.User]

    if (user.value.isCanteenAdmin) r.push(Role.CanteenAdmin)
    if (user.value.isProductionWorkerAdmin) r.push(Role.PasswordAdmin)

    return r
  })

  const hasRole = (required?: Role | Role[]) => {
    if (!required) return true
    const requiredRoles = Array.isArray(required) ? required : [required]
    return requiredRoles.some(role => roles.value.includes(role))
  }

  return {
    isAuthenticated: computed(() => !!session.value.data),
    isPending: computed(() => session.value.isPending),
    employeeName: computed(() => user.value?.name),
    department: computed(() => user.value?.department),
    employeeId: computed(() => user.value?.employeeId),
    employeeType: computed(() => user.value?.employeeType),
    companyKey: computed(() => user.value!.companyKey as CompanyKey),
    roles,
    hasRole,
  }
}
